var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24516 0.9375H10.4773C10.8071 0.981593 11.1406 1.0147 11.4667 1.06982C13.482 1.41338 15.3431 2.38078 16.7946 3.83929C18.2461 5.29779 19.2169 7.17592 19.5739 9.21603C19.6391 9.58348 19.6753 9.95092 19.7261 10.3184V11.5676C19.6971 11.8065 19.6717 12.0454 19.6391 12.2806C19.3724 14.411 18.415 16.3911 16.9174 17.9097C14.3805 20.4818 11.3326 21.4189 7.82812 20.7171C5.5047 20.2632 3.43472 18.9397 2.02955 17.0095C1.00235 15.6456 0.338696 14.0367 0.102424 12.3374C-0.133848 10.6382 0.0651953 8.90587 0.680459 7.30722C1.29572 5.70858 2.3065 4.29745 3.61545 3.20954C4.9244 2.12163 6.48749 1.39353 8.1543 1.09548C8.52033 1.04403 8.88637 0.988942 9.24516 0.9375ZM10.6948 9.2381V8.50321C10.6948 7.50009 10.6948 7.48538 11.6914 7.48538H12.467V5.51584C12.4465 5.51354 12.4258 5.51354 12.4054 5.51584C11.6805 5.51584 10.9775 5.4828 10.2671 5.54527C9.86139 5.56295 9.47135 5.70936 9.15208 5.96385C8.83281 6.21833 8.60042 6.56806 8.48769 6.96364C8.39 7.31199 8.33404 7.67096 8.32099 8.03287C8.29562 8.43339 8.32099 8.83761 8.32099 9.26385H7.20841V11.3215H8.32825V17.0977H10.7093V11.3031H12.3111L12.5141 9.26017L10.6948 9.2381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7092 9.23803H12.5213L12.3184 11.281H10.7165V17.0756H8.33546V11.2993H7.21558V9.24171H8.3282C8.3282 8.81547 8.31008 8.41125 8.3282 8.01073C8.34125 7.64882 8.39721 7.28985 8.4949 6.9415C8.60763 6.54592 8.84002 6.19619 9.15929 5.94171C9.47856 5.68722 9.8686 5.54081 10.2743 5.52313C10.9992 5.46066 11.6986 5.49747 12.4126 5.49379C12.4331 5.49149 12.4537 5.49149 12.4742 5.49379V7.46324H11.6986C10.7201 7.46324 10.702 7.46325 10.702 8.48107L10.7092 9.23803Z",
    fill: "#2F383B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.726,
    height: 20,
    fill: "white",
    transform: "translate(0 0.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bb31ba6a7f9cdd7c209d9aaa07f823c3.svg";
export { ForwardRef as ReactComponent };